require('./openYoungAddDocumentationView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
// @ utilities
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
// @ actions
const openYoungDocumentationActions = require('actions/openYoungDocumentation');
const uploadDocumentsOpenYoungActions = require('actions/uploadDocumentsOpenYoung');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ components
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const OpenYoungAddDocumentationError = require('./openYoungAddDocumentationError');
const OpenYoungAddDocumentationSuccess = require('./openYoungAddDocumentationSuccess');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { UploadDocumentsOpenYoung } = require('components/hire/packOpenYoung/uploadDocumentsOpenYoung/uploadDocumentsOpenYoung');

class OpenYoungAddDocumentationView extends React.Component {
    constructor(props){
        super(props)

        if (!props.openYoungAddDocumentationEnabled) {
            props.history.push('/myprofile/cards');
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRetryButton = this.handleRetryButton.bind(this);
    }

    componentDidMount() {
        const {
            getCardBeneficiary,
            immCards,
            immOpenYoungDocumentation,
            match: { params: { cardId } },
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        if (!!immCard) {
            const tagging = immCard.get('tagging');

            recordPath('upload-documentation', PAGE_GENERIC, '', '', tagging);

            if (!immOpenYoungDocumentation.get('fetchBeneficiarySuccess')) {
                getCardBeneficiary(immCard);
            }
        }
    }

    componentWillUnmount() {
        this.props.resetAddDocumentation();
        this.props.resetUploadDocument();
    }

    handleSubmit() {
        const {
            immCards,
            immOpenYoungDocumentation,
            match: { params: { cardId } },
            sendFiles,
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const immCardBeneficiary = immOpenYoungDocumentation.get('cardBeneficiary');

        sendFiles(immCard, immCardBeneficiary);
    }

    handleRetryButton() {
        const {
            getCardBeneficiary,
            immCards,
            match: { params: { cardId } },
        } = this.props;

        getCardBeneficiary(immCards.getIn(['byId', cardId]));
    }

    buildHeader(confirmationTitleTranslate) {
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

        return (
            <React.Fragment>
                <PreLeaveModalComponent
                    acceptText={acceptText}
                    cancelText={cancelText}
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                />
                <header className="open-young-add-doc__header">
                    <FormattedText value={confirmationTitleTranslate} />
                </header>
            </React.Fragment>
        );
    }

    buildTwoColumnSection(immCard, content) {
        return (
            <React.Fragment>
                <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                    <CardDetailsSideBar immCard={immCard} />
                </div>
                <div className="col-md-12 col-lg-8">
                    <OKSectionBox>
                        {content}
                    </OKSectionBox>
                </div>
                <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                    <CardDetailsSideBar immCard={immCard} />
                </div>
            </React.Fragment>
        );
    }

    buildFooter(submitButton) {
        return (
            <footer className="open-young-add-doc__footer">
                <div className="open-young-add-doc__cancel-button">
                    <OKLink
                        modifier="inherit-styles"
                        to="/myprofile/cards"
                    >
                        <FormattedText value="cardRequests-cancel" />
                    </OKLink>
                </div>
                {submitButton}
            </footer>
        );
    }

    buildEmptyState() {
        const { immVariables } = this.props;
        const retryButton = (
            <OKButton onClick={this.handleRetryButton}>
                <FormattedText value="common-retry" />
            </OKButton>
        );
        const primaryText = formatText('openYoungAddDocumentation-openYoungAddDocumentation_errorModalText', [immVariables.getIn(['telefono', 'cliente'])]);

        return (
            <EmptyState
                button={retryButton}
                iconType="nointernet-banking"
                primaryText={primaryText}
            />
        );
    }

    render() {
        const {
            immCards,
            immOpenYoungDocumentation,
            immUploadDocumentsOpenYoung,
            immVariables,
            match: { params: { cardId } },
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        let block = <LoadingSection />;
        let sectionContent;

        if (!!immCard) {
            const subtitleLeft = formatText(`cards-${immCard.get('type')}`);
            const subtitleRight = immCard.getIn(['alias', 'current']);
            const pageTitleKey = "breadcrumb-breadcrumb_uploadDocumentation";
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: subtitleRight,
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText(pageTitleKey),
                    url: ''
                }
            ];

            if (immUploadDocumentsOpenYoung.get('submitSuccessful')) {
                sectionContent = <OpenYoungAddDocumentationSuccess immCard={immCard} />;
            } else if (immUploadDocumentsOpenYoung.get('error')) {
                sectionContent = (
                    <OpenYoungAddDocumentationError
                        immCard={immCard}
                        immVariables={immVariables}
                    />
                );
            } else {
                const isButtonDisabled = !immUploadDocumentsOpenYoung.get('valid');
                const isButtonLoading = immUploadDocumentsOpenYoung.get('isFetching');
                const header = this.buildHeader("openYoungAddDocumentation-openYoungAddDocumentation_title");

                let body;
                let footer;

                if (immOpenYoungDocumentation.get('isFetching')) {
                    body = <LoadingSection />;
                } else if (immOpenYoungDocumentation.get('error')) {
                    body = this.buildEmptyState();
                } else if (immOpenYoungDocumentation.get('fetchBeneficiarySuccess')) {
                    body = (
                        <UploadDocumentsOpenYoung
                            immUploadDocumentsOpenYoung={immUploadDocumentsOpenYoung}
                        />
                    );
                    footer = this.buildFooter((
                        <OKButton
                            disabled={isButtonDisabled}
                            loading={isButtonLoading}
                            onClick={this.handleSubmit}
                        >
                            <FormattedText value="openYoungAddDocumentation-openYoungAddDocumentation_addDocumentation" />
                        </OKButton>
                    ));
                }

                sectionContent = this.buildTwoColumnSection(immCard, (
                    <article>
                        {header}
                        {body}
                        {footer}
                    </article>
                ));
            }

            block = (
                <React.Fragment>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover
                                customClass="col-xs-12"
                                section="cards"
                                size="medium"
                            >
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={getFinalTitle(pageTitleKey)}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                >
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {sectionContent}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        return block;
    }
}

OpenYoungAddDocumentationView.propTypes = {
    getCardBeneficiary: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immOpenYoungDocumentation: PropTypes.object.isRequired,
    immUploadDocumentsOpenYoung: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    openYoungAddDocumentationEnabled: PropTypes.bool,
    match: PropTypes.object.isRequired,
    resetAddDocumentation: PropTypes.func.isRequired,
    resetUploadDocument: PropTypes.func.isRequired,
    sendFiles: PropTypes.func.isRequired,
};

module.exports.constructor = OpenYoungAddDocumentationView;
module.exports.OpenYoungAddDocumentationView = connect(
    state => ({
        immCards: state.cards,
        immOpenYoungDocumentation: state.openYoungDocumentation,
        immUploadDocumentsOpenYoung: state.uploadDocumentsOpenYoung,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
        openYoungAddDocumentationEnabled: state.flagBasedFeatures.get('add-documentation-openyoung-enabled'),
    }), {
        getCardBeneficiary: openYoungDocumentationActions.getCardBeneficiary,
        resetAddDocumentation: openYoungDocumentationActions.reset,
        resetUploadDocument: uploadDocumentsOpenYoungActions.reset,
        sendFiles: uploadDocumentsOpenYoungActions.sendFiles,
    })(withRouter(OpenYoungAddDocumentationView));
